module.exports = __webpack_public_path__ + "static/media/blog_banner.054dd6fd.jpg";